

class Technology {
    constructor(age, type, name, scienceCost, workerCost, effects)
    {
        this.age = age;
        this.type = type;
        this.name = name;
        this.scienceCost = scienceCost;
        this.workerCost = workerCost;
        this.effects = effects;
        this.contents = {};
    }

    GetWorkerCount() {
        if (this.contents.workers === undefined || this.contents.workers === null)
        {
            return 0;
        }
        return this.contents.workers;
    }

    GetBlueCubeCount() {
        if (this.contents.blueCubes === undefined || this.contents.blueCubes === null)
        {
            return 0;
        }
        return this.contents.blueCubes;
    }

    AddContent(type, ammount=1) {
        if (this.contents[type] === undefined)
        {
            this.contents[type]=ammount;
        } else {
            this.contents[type]+=ammount;
        }
    }
}

module.exports = Technology;